export interface GetPopupAnchor {
    (anchor?: HTMLElement | null, isForm?: boolean): (trigger: HTMLElement) => HTMLElement
}

export const getPopupAnchor: GetPopupAnchor =
    (anchor?: HTMLElement | null, isForm = false) =>
    (trigger: HTMLElement) => {
        const formFallback = document.querySelector(".ant-modal-content")
        const formDrawerFallback = document.querySelector(".ant-drawer-content")
        if (!anchor && isForm && formDrawerFallback) {
            return formDrawerFallback as HTMLElement
        }
        if (!anchor && isForm && formFallback) {
            return formFallback as HTMLElement
        }
        if (!anchor) {
            return trigger.parentElement ?? document.body
        }
        return anchor
    }

// Add test id to all modal content elements
export const addTestIdToModalContent = () => {
    const modalContents = document.querySelectorAll(".ant-modal-content")
    modalContents.forEach((element) => {
        if (!element.getAttribute("data-testid")) {
            element.setAttribute("data-testid", "finway:generic:modal")
        }
    })
}

// Auto-run when DOM is ready
if (typeof window !== "undefined") {
    const observer = new MutationObserver(() => {
        addTestIdToModalContent()
    })

    if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true })
    } else {
        document.addEventListener("DOMContentLoaded", () => {
            observer.observe(document.body, { childList: true, subtree: true })
        })
    }
}
